import { theme } from "@/config/theme";
import { ConfigProvider } from "antd";
import { RouterProvider } from "react-router-dom";
import { router } from "@/app/router";

function App() {
  return (
    <ConfigProvider theme={theme}>
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}

export default App;
